import { Link } from "react-router-dom";

function NotFound() {
    return (
        <div style={{ textAlign: "center", padding: "50px" }}>
            <h1>404 :/</h1>
            <h2>Page non trouvée</h2>
            <p>La page que vous cherchez n’existe pas.</p>
            <Link to="/">Retour à l’accueil</Link>
        </div>
  );
}

export default NotFound;